/**
 * Formatting utilities for guest-facing hangout details
 * Story 4.3 - Guest Hangout Details View
 */

/**
 * Converts timeframe codes to human-readable text
 * @param timeframe - Timeframe code (today, tomorrow, this_weekend, next_week, this_month)
 * @returns Human-readable timeframe string
 */
export function formatTimeframe(timeframe: string): string {
  const map: Record<string, string> = {
    today: 'Today',
    tomorrow: 'Tomorrow',
    this_weekend: 'This weekend',
    next_week: 'Next week',
    this_month: 'This month',
  };
  return map[timeframe] || timeframe;
}

/**
 * Converts duration codes to human-readable text
 * Handles both standard duration codes and custom durations
 * @param duration - Duration code (quick, coffee, lunch, dinner, custom)
 * @param customDuration - Optional custom duration object with hours and minutes
 * @returns Human-readable duration string
 */
export function formatDuration(
  duration: string,
  customDuration?: { hours: number; minutes: number }
): string {
  // Handle custom duration
  if (duration === 'custom' && customDuration) {
    const { hours, minutes } = customDuration;
    const parts: string[] = [];

    if (hours > 0) {
      parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
    }

    return parts.join(' ');
  }

  // Handle standard durations
  const map: Record<string, string> = {
    quick: '15 minutes',
    coffee: '30 minutes',
    lunch: '1 hour',
    dinner: '2 hours',
  };

  return map[duration] || duration;
}
